import axios from 'axios';
import fnc from '../../mymod/commFunction';

const serverUrl = (process.env.REACT_APP_SERVER_URL
  || (process.env.NODE_ENV === 'development' ? 'http://localhost:8002' : '')).replace(/\/$/, '');

export async function fetchGuardianScheduleWeek({ studentId, startDate, endDate }) {
  const token = fnc.getCookie('appSessionToken');
  if (!token) throw new Error('다시 로그인한 뒤 자녀의 학습 스케줄을 확인해 주세요.');
  if (!studentId) throw new Error('조회할 자녀를 선택해 주세요.');

  try {
    const response = await axios.post(`${serverUrl}/scheduler/guardian/week`,
      { studentId, startDate, endDate },
      { headers: { Authorization: `Bearer ${token}` }, timeout: 20000 });
    if (fnc.getCookie('appSessionToken') !== token) {
      throw new Error('로그인 정보가 변경되었습니다. 다시 학습 스케줄을 확인해 주세요.');
    }
    if (!Array.isArray(response.data?.plans) || !Array.isArray(response.data?.reports)) {
      throw new Error(response.data?.error?.message || response.data?.error || '학습 스케줄을 불러오지 못했습니다.');
    }
    return response.data;
  } catch (error) {
    const message = error.response?.data?.error?.message || error.response?.data?.error;
    if (typeof message === 'string') throw new Error(message);
    if (error.response?.status === 401) throw new Error('로그인이 만료되었습니다. 다시 로그인해 주세요.');
    if (error.code === 'ERR_NETWORK' || error.code === 'ECONNABORTED') {
      throw new Error('학습 스케줄을 불러오지 못했습니다. 잠시 후 다시 확인해 주세요.');
    }
    throw error;
  }
}
